import { getRandomInteger } from "./helper";

(function(global) {

    if(typeof (global) === "undefined") {
        throw new Error("global is undefined");
    }
    let _hash = `#${getRandomInteger(0,100)}`;
    // if(global.location.hash == '' || global.location.hash == null)
    const noBackPlease = function () {
      console.log('noBackPlease', _hash);
      global.location.hash = _hash;
        // global.location.href += "#";
    
        // global.setTimeout(function () {
        //     global.location.href += "!";
        // }, 50);
    
    };
    
    global.onhashchange = function () {
      if (global.location.hash !== _hash) {
        _hash = `#${getRandomInteger(0,100)}`
        global.location.hash = _hash;
      }
    };
    
    global.onload = function () {
        setTimeout(function(){
          noBackPlease();
        }, 3*500)
    
        // Disables backspace on page except on input fields and textarea..
        document.body.onkeydown = function (e) {
            var elm = e.target.nodeName.toLowerCase();
            if (e.which === 8 && (elm !== 'input' && elm  !== 'textarea')) {
                e.preventDefault();
            }
            // Stopping the event bubbling up the DOM tree...
            e.stopPropagation();
        };
    }
})(window)